import { render, staticRenderFns } from "./navBack.vue?vue&type=template&id=193c14fa&scoped=true&"
import script from "./navBack.vue?vue&type=script&lang=js&"
export * from "./navBack.vue?vue&type=script&lang=js&"
import style0 from "./navBack.vue?vue&type=style&index=0&id=193c14fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193c14fa",
  null
  
)

export default component.exports